export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const isAdmin = () => {
  // Determine admin by any of these signals:
  // - Explicit flag set during special admin login
  // - Username equals "administrator"
  // - userType equals "Admin"
  const flag = localStorage.getItem('isAdmin') === 'true';
  const username = (localStorage.getItem('loggedInUsername') || '').toLowerCase();
  const userType = localStorage.getItem('userType') || '';
  return flag || username === 'administrator' || userType === 'Admin';
};
